import styled from 'styled-components';
import { s } from './VIPReport.style';

const ExpectedPeriod = () => {
  return (
    <s.Div>
      <s.Title>⏳예상 보유 기간</s.Title>
      <s.TopDescription>
        과거 유사 물건 분석 결과,
        <br />
        매입 후 평균 5~6개월 내 매각이 이루어진 사례가 다수 확인됨.
      </s.TopDescription>
      <s.Table>
        <s.TableHeader>
          <s.Header>항목</s.Header>
          <s.Header>평균 매각 기간</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>
            <Month>3개월 이내</Month>
            단기
          </RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>
            <Month>6개월</Month>중기
          </RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>
            <Month>12개월 이상</Month>장기
          </RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
      </s.Table>
    </s.Div>
  );
};

export default ExpectedPeriod;

const RowLeft = styled.div`
  width: 50%;
  height: 94px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const RowRight = styled.div`
  width: 50%;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Month = styled.div`
  width: fit-content;
  padding: 4px 8px;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
  color: rgba(55, 56, 60, 0.61);
`;
